import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import type { AvatarProps } from "./Avatar.types";

const AvatarSizeContext = createContext<AvatarProps["size"]>("medium");

export const AvatarProvider = ({
  size,
  children,
}: Pick<AvatarProps, "size"> & PropsWithChildren) => {
  return <AvatarSizeContext.Provider value={size}>{children}</AvatarSizeContext.Provider>;
};

export const useAvatarSizeContext = () => useContext(AvatarSizeContext);
